import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll(".fade-in");
  if (!images) return;

  gsap.registerPlugin(ScrollTrigger);

  gsap.set(".fade-in", {
    autoAlpha: 0,
  });

  ScrollTrigger.batch(".fade-in", {
    interval: 0.1,
    start: "top 80%",
    onEnter: (batch) => {
      gsap.to(batch, {
        autoAlpha: 1,
        duration: 0.4,
      });
    },
  });
});
